/**
 * Dashboard Redux Reducers
 * ========================
 */

import {
    DASHBOARD_STATS_REQUEST,
    DASHBOARD_STATS_SUCCESS,
    DASHBOARD_STATS_FAIL,
    DASHBOARD_STATS_RESET,
    DASHBOARD_ADMIN_STATS_REQUEST,
    DASHBOARD_ADMIN_STATS_SUCCESS,
    DASHBOARD_ADMIN_STATS_FAIL,
    DASHBOARD_ADMIN_STATS_RESET,
    DASHBOARD_TUTORIALS_REQUEST,
    DASHBOARD_TUTORIALS_SUCCESS,
    DASHBOARD_TUTORIALS_FAIL,
    DASHBOARD_LIVE_FLOOR_REQUEST,
    DASHBOARD_LIVE_FLOOR_SUCCESS,
    DASHBOARD_LIVE_FLOOR_FAIL,
    DASHBOARD_ACTIVE_SESSIONS_REQUEST,
    DASHBOARD_ACTIVE_SESSIONS_SUCCESS,
    DASHBOARD_ACTIVE_SESSIONS_FAIL,
    DASHBOARD_DEALER_STATUS_REQUEST,
    DASHBOARD_DEALER_STATUS_SUCCESS,
    DASHBOARD_DEALER_STATUS_FAIL,
    DASHBOARD_ALERTS_REQUEST,
    DASHBOARD_ALERTS_SUCCESS,
    DASHBOARD_ALERTS_FAIL,
    DASHBOARD_REVENUE_CHART_REQUEST,
    DASHBOARD_REVENUE_CHART_SUCCESS,
    DASHBOARD_REVENUE_CHART_FAIL,
    DASHBOARD_PLAYER_GROWTH_REQUEST,
    DASHBOARD_PLAYER_GROWTH_SUCCESS,
    DASHBOARD_PLAYER_GROWTH_FAIL,
    DASHBOARD_CLUB_REVENUE_REQUEST,
    DASHBOARD_CLUB_REVENUE_SUCCESS,
    DASHBOARD_CLUB_REVENUE_FAIL,
    DASHBOARD_RECENT_TXN_REQUEST,
    DASHBOARD_RECENT_TXN_SUCCESS,
    DASHBOARD_RECENT_TXN_FAIL,
    DASHBOARD_PENDING_APPROVALS_REQUEST,
    DASHBOARD_PENDING_APPROVALS_SUCCESS,
    DASHBOARD_PENDING_APPROVALS_FAIL,
    DASHBOARD_HIGHLIGHTS_REQUEST,
    DASHBOARD_HIGHLIGHTS_SUCCESS,
    DASHBOARD_HIGHLIGHTS_FAIL,
} from '../constants/dashboardConstants';

// User Dashboard Stats Reducer
export const dashboardStatsReducer = (state = { stats: null }, action) => {
    switch (action.type) {
        case DASHBOARD_STATS_REQUEST:
            return { loading: true, stats: null };
        case DASHBOARD_STATS_SUCCESS:
            return { loading: false, stats: action.payload };
        case DASHBOARD_STATS_FAIL:
            return { loading: false, error: action.payload };
        case DASHBOARD_STATS_RESET:
            return { stats: null };
        default:
            return state;
    }
};

// Admin Dashboard Stats Reducer
export const dashboardAdminStatsReducer = (state = { stats: null }, action) => {
    switch (action.type) {
        case DASHBOARD_ADMIN_STATS_REQUEST:
            return { loading: true, stats: null };
        case DASHBOARD_ADMIN_STATS_SUCCESS:
            return { loading: false, stats: action.payload };
        case DASHBOARD_ADMIN_STATS_FAIL:
            return { loading: false, error: action.payload };
        case DASHBOARD_ADMIN_STATS_RESET:
            return { stats: null };
        default:
            return state;
    }
};

// Poker Tutorials Reducer
export const dashboardTutorialsReducer = (state = { tutorials: [] }, action) => {
    switch (action.type) {
        case DASHBOARD_TUTORIALS_REQUEST:
            return { loading: true, tutorials: [] };
        case DASHBOARD_TUTORIALS_SUCCESS:
            return { loading: false, tutorials: action.payload };
        case DASHBOARD_TUTORIALS_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

// Live Floor Status Reducer
export const dashboardLiveFloorReducer = (state = { data: null }, action) => {
    switch (action.type) {
        case DASHBOARD_LIVE_FLOOR_REQUEST:
            return { loading: true, data: null };
        case DASHBOARD_LIVE_FLOOR_SUCCESS:
            return { loading: false, data: action.payload };
        case DASHBOARD_LIVE_FLOOR_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

// Active Sessions Reducer
export const dashboardActiveSessionsReducer = (state = { data: null }, action) => {
    switch (action.type) {
        case DASHBOARD_ACTIVE_SESSIONS_REQUEST:
            return { loading: true, data: null };
        case DASHBOARD_ACTIVE_SESSIONS_SUCCESS:
            return { loading: false, data: action.payload };
        case DASHBOARD_ACTIVE_SESSIONS_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

// Dealer Status Reducer
export const dashboardDealerStatusReducer = (state = { data: null }, action) => {
    switch (action.type) {
        case DASHBOARD_DEALER_STATUS_REQUEST:
            return { loading: true, data: null };
        case DASHBOARD_DEALER_STATUS_SUCCESS:
            return { loading: false, data: action.payload };
        case DASHBOARD_DEALER_STATUS_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

// Dashboard Alerts Reducer
export const dashboardAlertsReducer = (state = { alerts: [] }, action) => {
    switch (action.type) {
        case DASHBOARD_ALERTS_REQUEST:
            return { loading: true, alerts: [] };
        case DASHBOARD_ALERTS_SUCCESS:
            return { loading: false, alerts: action.payload };
        case DASHBOARD_ALERTS_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

// Revenue Chart Reducer
export const dashboardRevenueChartReducer = (state = { data: [] }, action) => {
    switch (action.type) {
        case DASHBOARD_REVENUE_CHART_REQUEST:
            return { loading: true, data: [] };
        case DASHBOARD_REVENUE_CHART_SUCCESS:
            return { loading: false, data: action.payload };
        case DASHBOARD_REVENUE_CHART_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

// Player Growth Reducer
export const dashboardPlayerGrowthReducer = (state = { data: null }, action) => {
    switch (action.type) {
        case DASHBOARD_PLAYER_GROWTH_REQUEST:
            return { loading: true, data: null };
        case DASHBOARD_PLAYER_GROWTH_SUCCESS:
            return { loading: false, data: action.payload };
        case DASHBOARD_PLAYER_GROWTH_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

// Club Revenue Reducer
export const dashboardClubRevenueReducer = (state = { data: null }, action) => {
    switch (action.type) {
        case DASHBOARD_CLUB_REVENUE_REQUEST:
            return { loading: true, data: null };
        case DASHBOARD_CLUB_REVENUE_SUCCESS:
            return { loading: false, data: action.payload };
        case DASHBOARD_CLUB_REVENUE_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

// Recent Transactions Reducer
export const dashboardRecentTxnReducer = (state = { transactions: [] }, action) => {
    switch (action.type) {
        case DASHBOARD_RECENT_TXN_REQUEST:
            return { loading: true, transactions: [] };
        case DASHBOARD_RECENT_TXN_SUCCESS:
            return { loading: false, transactions: action.payload };
        case DASHBOARD_RECENT_TXN_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

// Pending Approvals Reducer
export const dashboardPendingApprovalsReducer = (state = { data: null }, action) => {
    switch (action.type) {
        case DASHBOARD_PENDING_APPROVALS_REQUEST:
            return { loading: true, data: null };
        case DASHBOARD_PENDING_APPROVALS_SUCCESS:
            return { loading: false, data: action.payload };
        case DASHBOARD_PENDING_APPROVALS_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

// Today's Highlights Reducer
export const dashboardHighlightsReducer = (state = { data: null }, action) => {
    switch (action.type) {
        case DASHBOARD_HIGHLIGHTS_REQUEST:
            return { loading: true, data: null };
        case DASHBOARD_HIGHLIGHTS_SUCCESS:
            return { loading: false, data: action.payload };
        case DASHBOARD_HIGHLIGHTS_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

